<template>
  <header class="header">
    <div class="h-left">
      <img :src="logo" class="main-logo">
      <b class="title">{{ $t("header.title") }}</b>
    </div>

    <div class="h-right">

      <span class="account">{{ userInfo.email }}</span>
      <div class="line"></div>

      <el-button type="text"
                 class="signOut"
                 @click="signOut">{{
        $t("header.logout")
      }}</el-button>
    </div>
  </header>
</template>

<script>
import { removeToken } from "@/utils/auth";
import { mapGetters, mapActions } from "vuex";
import { logout } from "@/api/api.js";
import llmlogo from '@/assets/image/llm_logo.svg';

export default {
  data() {
    return {
      langValue: "en_us",
      logo: llmlogo,
    };
  },
  mounted() {},
  methods: {
    async signOut() {
      await logout();
      this.reset();
      removeToken();
      this.$router.push("/login");
    },
    ...mapActions(["reset"])
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {}
};
</script>
<style>
.header-tips {
  font-size: 16px !important;
}
</style>
<style lang="less" scoped>
.header {
  height: 60px;
  background: #333;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  .title {
    font-size: 26px;
    color: #F16622;
  }
  .main-logo {
    position: relative;
    left: 0;
    top: 5px;
    height: 40px;
  }
  .h-left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 350px;
    height: 100%;
  }
  .h-right {
    display: flex;
    align-items: center;
    color: #fff;
    .signOut,
    .language,
    .line,
    .account {
      margin-left: 16px;
    }
    .line {
      width: 2px;
      height: 14px;
      background: #fff;
    }
    .language {
      color: #fff;
    }
    .avatar {
      margin-left: 30px;
    }
    .question {
      margin-right: 10px;
    }
  }
}
</style>
